import React, { useState, useEffect } from "react";
import { SidebarView } from "./sidebar-view";
import "./sidebar.scss";
export const SidebarControler = (props) => {
	
	return <SidebarView  expanded={props.expanded} handleExpand={props.handleExpand} handleChange={props.handleChange} {...props} />;
};
